module.exports = __webpack_public_path__ + "static/20200301_214014_optimized-a8906589a15a0745b4e94b9f72201b83.jpg";